import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vuetify.config.silent = true;

// Vue.use(Vuetify, {
// });

Vue.use(Vuetify);

// '#01579B' - blue
// '#263238' - grey
// '#263238' - grey
// '#01579B' - blue
// secondary: '#b0bec5',
// accent: '#8c9eff',
// error: '#b71c1c'
// 43A4D9

// '#0288D1', /* light-blue darken-2 */

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#004C6E' /* darkblue; */,
        secondary: '#00838F' /*  '#0288D1', light-blue darken-2 */ /* cyan darken-3 */,
        mybits: '#2B81D6',
        success: '#43A047' /* green darken-1 */,
        info: '#00695C' /* teal darken-3 */,
        error: '#F44336' /* '#CF3015', */,
        calltoaction: '#00ACC1' /* '#F9A825', yellow darken-3 */
        // anchor: '#8c9eff',
      }
    }
  }
});

export default vuetify;
